export default "/images/79bf64b373884213f6e4226f13449d61.avif";